import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: 20px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: 40px;
  }
`;

export const LinearProgressStyled = styled.div`
  height: 48px;
  width: 100%;
  border-radius: ${p => p.theme.radii.eBid};
  background-color: ${({ theme }) => theme.colors.white};
  overflow: hidden;

  &:before {
    content: "";
    display: block;
    height: 100%;
    width: ${({ progress }) => `${progress}%`};
    background-color: ${({ theme }) => theme.colors.accent.green};
    transition: width 0.5s ease;
  }

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    height: 65px;
  }
`;

export const ProgressText = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  color: ${p => p.theme.colors.black};
  font-weight: ${p => p.theme.fontWeight.medium};
  font-size: 16px;
  transform: translate(-50%, -50%);

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 28px;
  }
`;

export const DotsWrapper = styled.span`
  display: inline-block;
  width: 1.5em;
  text-align: left;
`;
